import React from "react";
import "../styles/map.css";
import { Link } from "react-router-dom";
const Map = () => {
  return (
    <div className="container map-container">
      <div className="map-content">
      <h1 className="map-heading">Visit Us At Our Office</h1>
        <Link
          onClick={() =>
            window.open(
              "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.606890445471!2d77.3138688750192!3d28.581564986394206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce342a06c32d5%3A0x5b918c5191395de3!2sTechbeliever%20Technologies%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1694685776848!5m2!1sen!2sin"
            )
          }
          className="open"
        >
          Open In Map
        </Link>
      </div>
      <div className="map-image">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.606890445471!2d77.3138688750192!3d28.581564986394206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce342a06c32d5%3A0x5b918c5191395de3!2sTechbeliever%20Technologies%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1694685776848!5m2!1sen!2sin"
          style={{
            width: "95%",
            height: "100%",
            border: "none",
            borderRadius: "20px",
          }}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
};

export default Map;
